export const useDevice = () => {
  return {
    isTouch: 'ontouchstart' in window,
  };
};
